import Vue from 'vue'
import 'normalize.css'

import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

import '@/assets/css/theme/index.css'
import '@/assets/css/iconfont/iconfont.css'
import '@/assets/css/iconfont-preSalePlan/iconfont.css'
// svg图标
import '@/assets/css/iconfont-folder/iconfont.js'
import '@/assets/font/font.css';
import './styles/button.css'

import './permission'
import './utils/filter'
import './components/index'

// import Permission from './directive/permission/'
// Vue.use(Permission);
// import NoPermission from './directive/no-permission/'
// Vue.use(NoPermission);
// import Debounce from './directive/debounce/'
// Vue.use(Debounce);

import Directives from './directive'
Vue.use(Directives)

import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import api from './api-new'
Vue.prototype.$api = api;

import QRequest from './api'
Vue.prototype.$q = QRequest;

import bus from '@/utils/bus'
Vue.prototype.$bus = bus;

import common from "./utils/common";
Vue.prototype.common = common //公共js方法

import pubJs from './utils/mixin.js'
Vue.mixin(pubJs)

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

import * as $excel from 'vue-table-to-excel'
Vue.prototype.$excel = $excel;

import './utils/vxe-table'
import {baseUrl} from './utils/constant'
import modulesPlugin from '@qy/public-platform-modules'
import '@qy/public-platform-modules/lib/public-platform-modules.css'
import './styles/index.styl'
console.log(modulesPlugin)

Vue.use(modulesPlugin, {
  BUILD_ENV: process.env.BUILD_ENV,
  baseUrl: baseUrl,
  router: router,
  layout: _=>import('@/layout'),
  serveName: 'ec-pc-api'
})
// import Layout from './layout'
// import qyPlugin from 'modules-plugin-qy'
// Vue.use(qyPlugin, {
//   BUILD_ENV: process.env.BUILD_ENV,
//   baseUrl: baseUrl,
//   router,
//   layout: Layout
// })   

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
